import React from 'react';

import { Icon, Input, InputGroup, InputLeftElement } from '@chakra-ui/react';
import { FaPaperclip } from '@react-icons/all-files/fa/FaPaperclip';
import { InternalFieldName, GlobalError, UseFormRegisterReturn } from 'react-hook-form';

import { FormControl } from '../FormControl/FormControl';

type FileUploadProps<TFieldName extends InternalFieldName = InternalFieldName> = {
	label: string;
	type?: string;
	error: GlobalError | undefined;
	helperText?: string;
	acceptedFileTypes?: string[];
	maxTotalMb?: number;
	allowMultiple?: boolean;
	className?: string;
} & Omit<UseFormRegisterReturn<TFieldName>, 'ref'>;

export const FileUpload = React.forwardRef<HTMLInputElement, FileUploadProps>((props, ref) => {
	const { type, acceptedFileTypes, maxTotalMb, allowMultiple, ...formControlProps } = props;
	const { helperText, required, className, ...inputProps } = props;
	return (
		<FormControl {...formControlProps}>
			<InputGroup>
				<InputLeftElement pointerEvents="none" children={<Icon as={FaPaperclip} />} />
				<Input
					type="file"
					id={props.name}
					ref={ref}
					multiple={allowMultiple}
					accept={!!acceptedFileTypes ? acceptedFileTypes.join(',') : undefined}
					py={2}
					bg="white"
					cursor="pointer"
					sx={{
						'::file-selector-button': {
							display: 'none',
						},
					}}
					{...inputProps}
				/>
			</InputGroup>
		</FormControl>
	);
});
